module.exports = __webpack_public_path__ + "img/icon-question-blue.f92f0251.svg";